"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Ingredient_1 = require("../model/Ingredient");

var IngredientConverter_1 = require("./IngredientConverter");
/**
 * Implementation of {@link IngredientConverter}
 *
 * @author Adam Drda
 */


var IngredientConverterImpl =
/*#__PURE__*/
function (_IngredientConverter_) {
  _inherits(IngredientConverterImpl, _IngredientConverter_);

  function IngredientConverterImpl() {
    _classCallCheck(this, IngredientConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(IngredientConverterImpl).apply(this, arguments));
  }

  _createClass(IngredientConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Ingredient_1.Ingredient(Ingredient_1.Ingredient.schema.externalId.valueOfField(source), Ingredient_1.Ingredient.schema.productId.valueOfField(source), Ingredient_1.Ingredient.schema.amount.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        externalId: source.externalId,
        productId: source.productId,
        amount: source.amount
      });
      return result;
    }
  }]);

  return IngredientConverterImpl;
}(IngredientConverter_1.IngredientConverter);

exports.IngredientConverterImpl = IngredientConverterImpl;